import { useMemo } from 'react';

import useInfiniteAPIQuery from '../api/useInfiniteAPIQuery';
import usePrefetchPages from './usePrefetchPages';

export const useSeniorityLevels = () => {
  const seniorityLevelPages = useInfiniteAPIQuery(['/seniority_levels/'], {
    staleTime: Infinity,
  });
  const seniorityLevels = usePrefetchPages(seniorityLevelPages, (data) => data.results);

  const defaultSelectedSeniorityLevelID = useMemo(
    () => seniorityLevels.find((sl) => sl.key === 'without_seniority')?.id,
    [seniorityLevels]
  );
  return {
    seniorityLevels,
    defaultSelectedSeniorityLevelID,
  };
};
